import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { STAFF_CLINICS_REPOSITORY } from '../domain/repositories/staff-clinics.repository';
import { StaffClinicsRemoteDatasource } from './datasources/remote/staff-clinics.remote-datasource';
import { StaffClinicMapper } from './mappers/staff-clinic.mapper';
import { StaffClinicsRepositoryImpl } from './repositories/staff-clinics.repository.impl';

export function provideStaffClinicsData(): EnvironmentProviders {
  return makeEnvironmentProviders([
    StaffClinicsRemoteDatasource,
    StaffClinicMapper,
    { provide: STAFF_CLINICS_REPOSITORY, useClass: StaffClinicsRepositoryImpl },
  ]);
}
